import { ApiGetRequest, ApiPostRequest } from '../../../api';
import { showNotif } from '../../notification';

export const state = {
  data: {
    title: 'Setting Saldo Awal',
    periode: {
      period_start: {
        tgl_period: ''
      },
      period_end: {
        tgl_period: ''
      }
    },
    kurs_mata_uang: []
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  periode(state) {
    return state.data.periode;
  }
};

export const mutations = {
  changeTutupTahunan(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getPeriodeYear({ commit }) {
    commit('changeTutupTahunan', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/tutup-buku/year-periode`);
    commit('changeTutupTahunan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTutupTahunan', {
        periode: result.data.object,
      });

      return true;
    }

    return false;
  },

  async prosesTutupTahunan({ commit, dispatch, state }) {
    commit('changeTutupTahunan', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`fin/tutup-buku/tahunan`, {
      kurs_mata_uang: data.kurs_mata_uang
    });
    commit('changeTutupTahunan', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });

      return true;
    }

    return false;
  },

  async getKursMataUang({ commit }) {
    commit('changeTutupTahunan', {
      loading: true,
    });

    let result = await ApiGetRequest(`fin/tutup-buku/kurs-mata-uang`);
    commit('changeTutupTahunan', {
      loading: false,
    });

    if (!result.error) {
      commit('changeTutupTahunan', {
        kurs_mata_uang: result.data.object
      })

      return true;
    }

    return false;
  },
};
